import { injectable } from 'inversify';
import { CoreState, HorizontalScrollType, ScrollDirection } from '../../../models';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

@injectable()
export class ScrollMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.setScrollDirection]: (localState: CoreState, direction: ScrollDirection) => {
      localState.scrollDirection = direction;
    },
    [CORE_MUTATIONS_KEYS.setScrollEnabled]: (localState: CoreState, enabled: boolean) => {
      localState.scrollEnabled = enabled;
    },
    [CORE_MUTATIONS_KEYS.setScrollOffset]: (localState: CoreState, offset: boolean) => {
      localState.scrollOffset = offset;
    },
    [CORE_MUTATIONS_KEYS.setFirstGridItemIdInView]: (localState: CoreState, gridItemId: string) => {
      localState.firstGridItemIdInView = gridItemId;
    },
    [CORE_MUTATIONS_KEYS.setHorizontalScrollType]: (localState: CoreState, horizontalScrollType: HorizontalScrollType) => {
      localState.horizontalScrollType = horizontalScrollType;
    }
  };
}
